import { MEASUREMENT_KEY } from 'app/xEcoApm/helper'

/**
 * Listens to bluetooth events until the current peripheral is disconnected. When that happens,
 * clears the cached measurement data.
 *
 * @param module  current module
 * @param name    peripheral identifier name
 */
const clearCacheOnDeviceDisconnection = (module: Gaia.AppModule.Spec, name?: string) => {
  const eventBus = module[G.ADAPTER][G.EVENTS]
  const storage = module[G.ADAPTER][G.STORAGE]
  let peripheralName = name

  if (!peripheralName) {
    const { sensor } = module[G.MODEL][G.CHILDREN]
    const { value: { name } } = sensor[G.CACHE]
    peripheralName = name
  }

  eventBus.add(eventBus.type(G.BLUETOOTH, G.DONE), async (event: any) => {
    const { pairedDevices = [] } = event?.detail?.[G.DATA] || {}
    const device = pairedDevices.find((device: any) => device.name === peripheralName)

    if (!device) {
      await storage.remove(MEASUREMENT_KEY)
    } else {
      // Device is still connected and listener won't execute again, so we re-register it
      clearCacheOnDeviceDisconnection(module, peripheralName)
    }
  }, { once: true })
}

/**
 * Saves the current measurement model data into the module's cache and initializes a listener that
 * clears the cache when the current peripheral disconnects.
 *
 * @param obj current module
 */
const cacheMeasurementData = (obj: Gaia.AppModule.Spec) => async (...args: unknown[])=> {
  const storage = obj[G.ADAPTER][G.STORAGE]
  const { sensor, measurement } = obj[G.MODEL][G.CHILDREN]
  const { value: { serial } } = sensor[G.CACHE]
  const data = { ...measurement[G.DATA] }
  const timestamp = new Date().toISOString()

  delete data.comment
  delete data.reference

  clearCacheOnDeviceDisconnection(obj)

  await storage.set(MEASUREMENT_KEY, JSON.stringify({ timestamp, serial, data }))

  return args
}

export default cacheMeasurementData
